module.exports = __webpack_public_path__ + "img/Jam Eater Blues.617dfb09.jpg";